import { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'types';

import styles from './Input.module.css';

type Props = {
  label?: any;
  onChange: any;
  name: string;
  type?: string;
  value: string;
  error?: any;
  whiteLabel?: boolean;
  maxLength?: number;
  pattern?: string;
};

export const Input: FC<Props> = ({
  label,
  onChange,
  value,
  name,
  type = 'text',
  error,
  whiteLabel,
  maxLength,
  pattern,
}) => {
  const { windowWidth } = useSelector((state: RootState) => state.app);

  return (
    <>
      {label && (
        <p
          style={{ fontSize: '12px', margin: '0 0 10px 0', color: whiteLabel ? '#F5F3F1' : '#000' }}
        >
          {label}
        </p>
      )}
      <input
        value={value}
        type={type}
        name={name}
        onChange={onChange}
        className={`${styles.main} ${error && styles.error}`}
        maxLength={maxLength}
        pattern={pattern}
      />
      {!!error && (
        <p style={{ color: windowWidth > 1140 ? 'red' : 'orange', fontSize: '12px' }}>
          {!!error && error}
        </p>
      )}
    </>
  );
};
